import { render, staticRenderFns } from "./total-spend-viewer.vue?vue&type=template&id=040ea49e&scoped=true"
import script from "./total-spend-viewer.vue?vue&type=script&lang=js"
export * from "./total-spend-viewer.vue?vue&type=script&lang=js"
import style0 from "./total-spend-viewer.vue?vue&type=style&index=0&id=040ea49e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ea49e",
  null
  
)

export default component.exports